import { StoreState } from './store.types';

import { RootState } from '~/redux/store';

export const selectSelectedStore = ({
  store,
}: RootState): StoreState['selectedStore'] => store.selectedStore;

export const selectRestorableStoreId = ({
  store,
}: RootState): StoreState['restorableStoreId'] => store.restorableStoreId;
